<template>
  <div class="condition-wrapper text-center py-5">
    <h4 class="condition-title mb-4">{{ headerText }}</h4>

    <CRow class="justify-content-center">
      <CCol cols="12" md="8">
        <template v-if="conditionImages.length">
          <img
              v-for="(img, idx) in conditionImages"
              :key="idx"
              :src="img"
              class="condition-image mb-3"
              alt="Condition Banner"
          />
        </template>
        <p v-else class="text-danger">⚠️ No condition images found.</p>
      </CCol>
    </CRow>

    <CRow class="justify-content-center mt-4">
      <CCol cols="auto">
        <button class="btn-submit px-5 py-2" @click="onSubmit">
          Submit
        </button>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import api from "@/service/api.js";
import "@/assets/css/condition.css";

export default {
  name: "condition_normal",
  data() {
    return {
      headerText: "Loading...",
      conditionImages: [],
      imageBaseURL: "https://election-su.mfu.ac.th", // เปลี่ยนเป็น baseURL ของ backend จริง
    };
  },
  methods: {
    async fetchCondition() {
      try {
        const { data } = await api.condition("get");
        const allConditions = data.data || [];

        const condition = allConditions.find(
            (c) => c.type === "686bacfd266df45e88c9ca59" ||
                c.type?._id === "686bacfd266df45e88c9ca59"
        );

        if (condition) {
          this.headerText = condition.condition_header || "Condition Header";
          if (condition.condition_imgs?.length) {
            this.conditionImages = condition.condition_imgs.map(
                (img) => `${this.imageBaseURL}${img}`
            );
          } else {
            this.conditionImages = [];
          }
        } else {
          this.headerText = "⚠️ Condition not found.";
          this.conditionImages = [];
        }
      } catch (err) {
        console.error(err);
        this.headerText = "⚠️ Failed to load condition.";
        this.conditionImages = [];
      }
    },
    onSubmit() {
      this.$router.push("/register/register_normal");
    },
  },
  mounted() {
    this.fetchCondition();
  },
};
</script>
